import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import {Link} from 'react-router-dom';
import './CategoryDetail.css';

function CategoryDetail() {
  const {category_slug} = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    // Fetch products for the category
    axios.get(`/api/v1/category/${category_slug}/products/`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error('Error fetching category products:', error);
      });

    // Fetch all categories and find the matching one
    axios.get(`/api/v1/category/`)
      .then((response) => {
        // Extract slug from get_absolute_url (remove leading/trailing slashes)
        const foundCategory = response.data.find(c => {
          const urlSlug = c.get_absolute_url.replace(/\//g, '');
          return urlSlug === category_slug;
        });

        if (foundCategory) {
          setCategory(foundCategory);
        } else {
          console.error('Category not found');
        }
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, [category_slug]);

  if (!category) {
    return <div>Loading...</div>;
  }

  return (
    <div className='category-detail'>
      <h1>{category.name}</h1>
      <div className='category-product-list'>
        {products.map((product) => (
          <div key={product.id} className='category-product-card'>

            {/* --- ADD THIS BADGE --- */}
            {product.stock_quantity === 0 && (
              <div className="product-badge-overlay">
                <span>Sold Out</span>
              </div>
            )}
            {/* --- END ADD --- */}

            <Link to={product.get_absolute_url}>
              <div className='category-img-wrapper'>
                <img src={product.get_image} alt={product.name} />
              </div>
              <h2>{product.name}</h2>
              <p className='product-description-text'>{product.description}</p>
            </Link>
            <div className='cat-btn-wrapper'>
              <button className='cat-button'>€{product.price}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoryDetail;
